<template>
  <form class="mx-2" style="display: inline-block">
      <b-dropdown :size="size || 'sm'" :text="buttonGroup.name" variant="primary">
        <b-dropdown-item :size="size || 'sm'" :key="menu.value" v-for="menu in buttonGroup.menus" @click="changeValue(buttonGroup, menu)">{{menu.name}}</b-dropdown-item>
      </b-dropdown>
  </form>
</template>

<script>
/*
  buttonGroup: {
    value: '',
    key: '',
    name: '',
    menus: [{
      name: '',
      value: ''
    }]
  }
*/

function changeValue (buttonGroup, menu) {
  buttonGroup.name = menu.name
  buttonGroup.value = menu.value

  let query = {}
  query[buttonGroup.key] = menu.value
  this.updateQuery(query)
}

function initSearch () {
  // 根据url里面的参数， 初始化每一个按钮的显示
  this.buttonGroup = this.pButtonGroup || []

  let query = this.$route.query
  for (let key in query) {
    // 查找buttonGroup
    if (this.buttonGroup.key !== key) {
      continue
    }

    for (let menu of this.buttonGroup.menus) {
      if (menu.value === query[key]) {
        this.buttonGroup.name = menu.name
        this.buttonGroup.value = menu.value
        break
      }
    }
  }
}

function updateQuery (obj) {
  let query = Object.assign({}, this.$route.query)
  // remove query
  for (let key in obj) {
    let value = obj[key]
    if (value === '' || value === 'all') {
      delete query[key]
    } else if (value === query[key]) {
      continue
    } else {
      query[key] = value
    }
  }

  query.page = 1
  this.$router.push({query: query})
}

export default {
  name: 'button-group',
  data () {
    return {
      buttonGroup: {},
    }
  },
  props: ['pButtonGroup', 'size'],
  methods: {
    changeValue,
    initSearch,
    updateQuery
  },
  mounted () {
    this.initSearch()
  }
}
</script>